// Either an array with a single function that takes a log function or an array of messages
type CallbackOrMessages = [(l: typeof console.log) => void] | any[];

class Debug {
  private debug() {
    return import.meta.env.DEV && !import.meta.env.VITEST;
  }

  log(...callbackOrMessages: CallbackOrMessages): void {
    if (!this.debug()) return;

    if (callbackOrMessages.length === 1 && typeof callbackOrMessages[0] === "function") {
      // eslint-disable-next-line no-console
      callbackOrMessages[0](console.log.bind(console));
    } else {
      // eslint-disable-next-line no-console
      console.log(...callbackOrMessages);
    }
  }

  error(...messages: any[]) {
    if (this.debug()) console.error(...messages);
  }

  warn(...messages: any[]) {
    if (this.debug()) console.warn(...messages);
  }

  info(...messages: any[]) {
    // eslint-disable-next-line no-console
    if (this.debug()) console.info(...messages);
  }

  time(label: string) {
    // eslint-disable-next-line no-console
    if (this.debug()) console.time(label);
  }

  timeEnd(label: string) {
    // eslint-disable-next-line no-console
    if (this.debug()) console.timeEnd(label);
  }
}

export default new Debug();
